import { useState, useEffect } from 'react';

export function useKeyboardOpen(): boolean {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.visualViewport) {
      return;
    }

    const vv = window.visualViewport;
    const handleResize = () => {
      const isKeyboard = vv.height < window.innerHeight * 0.75;
      setIsOpen(isKeyboard);
    };

    vv.addEventListener('resize', handleResize);
    return () => vv.removeEventListener('resize', handleResize);
  }, []);

  return isOpen;
}
